import React from 'react';
import PropTypes from 'prop-types';
import Divider from 'components/divider';
import Colors from 'common/constants/colors';
import styles from './index.css';

export default class HeatmapRow extends React.Component {
  static propTypes = {
    columnWidth: PropTypes.number,
    day: PropTypes.array,
    height: PropTypes.number,
    width: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    columnWidth: 0,
    day: [],
    height: 0,
    width: 0,
    y: 0,
  };

  render() {
    return (
      <g
        className={styles.HeatmapRow}
        transform={`translate(0 ${this.props.y})`}>
        {this.props.day.map((hour, index) => (
          <rect
            fill={hour.color}
            height={this.props.height}
            key={`hourCell${index}`}
            width={this.props.columnWidth}
            x={this.props.columnWidth * index}
          />
        ))}

        <Divider
          style={{
            stroke: Colors.gray300,
            strokeOpacity: 0.25,
          }}
          x1={0}
          x2={this.props.width}
          y1={this.props.height}
          y2={this.props.height}
        />
      </g>
    );
  }
}
